import { render } from "./RelatorioConcentracaoContratosAtivosView.vue?vue&type=template&id=ae1cba8a"
import script from "./RelatorioConcentracaoContratosAtivosView.vue?vue&type=script&lang=js"
export * from "./RelatorioConcentracaoContratosAtivosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__